import React from 'react';
import Header from './Header';
import Body from './Body';
import * as styles from './styles.scss';

const Table = ({
    className,
    columns,
    rows,
    labels,
    rowClassName,
    confirmation = []
}) => (
    <div className={`${styles.table}${className ? ` ${className}`: ''}`}>
        {
            !!columns?.length &&
            <Header
                columns={columns}
                className={`${styles.head}${!!rowClassName ? ` ${rowClassName}` : ''}`}
            />
        }
        <Body
            rows={rows}
            className={`${styles.row}${!!rowClassName ? ` ${rowClassName}` : ''}`}
            labels={labels}
            confirmation={confirmation}
        />
    </div>
);

export default Table;
